module.exports = __webpack_public_path__ + "static/media/app-condutor-icone-ios.58099700.jp2";